import { Pipe, PipeTransform } from '@angular/core';
import {TemplateDefinition} from '../../../model/template-definition';
import {ComponentType} from '../../../model/component-type.enum';

@Pipe({
  name: 'componentTypeFilter',
  pure: false
})
export class ComponentTypeFilterPipe implements PipeTransform {

  transform(definitions: TemplateDefinition[], filter: ComponentType): TemplateDefinition[] {
    if (!definitions || !filter) {
      return definitions;
    }
    return definitions.filter(definition => definition.templateComponent.componentType === filter);
  }

}
